import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const SaveIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8787 3H11C7.22876 3 5.34315 3 4.17157 4.17157C3 5.34315 3 7.22876 3 11V13C3 16.7712 3 18.6569 4.17157 19.8284C5.34315 21 7.22876 21 11 21H13C16.7712 21 18.6569 21 19.8284 19.8284C21 18.6569 21 16.7712 21 13V8.12132C21 7.66475 21 7.43646 20.9758 7.2174C20.8924 6.4633 20.5963 5.74846 20.122 5.15629C19.9843 4.98427 19.8228 4.82285 19.5 4.5C19.1772 4.17715 19.0157 4.01573 18.8437 3.87795C18.2515 3.40366 17.5367 3.10757 16.7826 3.02421C16.5635 3 16.3353 3 15.8787 3Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 3.5V4C17 5.88562 17 6.82843 16.4142 7.41421C15.8284 8 14.8856 8 13 8H11C9.11438 8 8.17157 8 7.58579 7.41421C7 6.82843 7 5.88562 7 4V3.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 20.5V17C17 15.1144 17 14.1716 16.4142 13.5858C15.8284 13 14.8856 13 13 13H11C9.11438 13 8.17157 13 7.58579 13.5858C7 14.1716 7 15.1144 7 17V20.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SaveIconMedium: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5858 2H7.33333C4.81917 2 3.5621 2 2.78105 2.78105C2 3.5621 2 4.81917 2 7.33333V8.66667C2 11.1808 2 12.4379 2.78105 13.2189C3.5621 14 4.81917 14 7.33333 14H8.66667C11.1808 14 12.4379 14 13.2189 13.2189C14 12.4379 14 11.1808 14 8.66667V5.41421C14 5.10983 14 4.95764 13.9839 4.8116C13.9283 4.30887 13.7309 3.83231 13.4147 3.43753C13.3229 3.32285 13.2152 3.21523 13 3C12.7848 2.78477 12.6771 2.67715 12.5625 2.5853C12.1677 2.26911 11.6911 2.07171 11.1884 2.01614C11.0423 2 10.8902 2 10.5858 2Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3334 2.33325V2.66659C11.3334 3.92367 11.3334 4.55221 10.9428 4.94273C10.5523 5.33325 9.92375 5.33325 8.66669 5.33325H7.33335C6.07627 5.33325 5.44773 5.33325 5.05721 4.94273C4.66669 4.55221 4.66669 3.92367 4.66669 2.66659V2.33325"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3334 13.6667V11.3334C11.3334 10.0763 11.3334 9.44781 10.9428 9.05728C10.5523 8.66675 9.92375 8.66675 8.66669 8.66675H7.33335C6.07627 8.66675 5.44773 8.66675 5.05721 9.05728C4.66669 9.44781 4.66669 10.0763 4.66669 11.3334V13.6667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
